export default __webpack_public_path__ + "static/media/float-center.5793f183.svg";